import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { withFirebase } from '../Firebase';
import DragScrollProvider from 'drag-scroll-provider';
import * as moment from 'moment';
import "./ReceivedCardCarousel.css";
import ReactiveCard from './ReactiveCard';
import shareImage from '../assets/share.svg'
import checkedImage from '../assets/checked.svg'
import refusedImage from "../assets/close.svg"

class ReceivedCardCarousel extends Component {

    render() {
        return (
            <ReceivedCardCarouselComponent {...this.props} />
        );
    }
}

const INITIAL_STATE = {
    active: 0,
    processedList: [],
    error: null,
};

class ReceivedCardCarouselComponentBase extends Component {

    constructor(props) {
        super(props);

        this.state = { ...INITIAL_STATE };
    }

    onOpenReceivedCapsule = (index, capsuleId) => {
        let { active } = this.state
        if (active === index) {
            this.props.history.push(`/capsule/${capsuleId}`);
        }
    }

    onChangeActive = (index, capsuleId) => {
        let { active } = this.state
        if (active !== index) {
            this.setState({
                active: index
            })
        }
    };


    render() {

        const { data, onAcceptCapsule, onDeclineCapsule, onDiffusionCapsule, ...other } = this.props;
        const nonProcessedAssignments = data.filter(assignment => assignment.accepted === null).sort((assignmentA, assignmentB) => moment(assignmentB.date).diff(moment(assignmentA.date)));
        const active = this.state.active;
        const processedList = this.state.processedList;
        return (

            <div className="received-card-carousel-container">
                <DragScrollProvider>
                    {({ onMouseDown, ref }) => (
                        <div className="received-card-scrolling-wrapper"
                            ref={ref}
                            onMouseDown={onMouseDown}>
                            {nonProcessedAssignments.map((assignment, index) => {
                                return (
                                    <div hidden={processedList.includes(assignment.assignedCapsule)} className="received-container" key={index} onClick={() => this.onChangeActive(index, assignment.assignedCapsule)}>
                                        <div className={active === index ? "received-active-container" : "received-inactive-container"} onClick={() => this.onOpenReceivedCapsule(index, assignment.assignedCapsule)}>
                                            <ReactiveCard
                                                cardIndex={index + 1}
                                                capsuleID={assignment.assignedCapsule}
                                                title={assignment.capsuleTitle}
                                                addressedTo={assignment.capsuleAssigneeName}
                                                nbPolls={assignment.capsulePolls.length}
                                                nbIdeas={assignment.capsuleIdeas.length}
                                                nbLikes={assignment.capsuleLikes}
                                                tagList={assignment.capsuleTags}
                                                picture={assignment.capsulePicture}
                                                active={active === index}
                                                from={assignment.from}
                                                importanceEstimation={assignment.importanceEstimation}
                                                timeEstimation={assignment.timeEstimation}
                                                {...other}
                                            />
                                        </div>

                                        {active === index ?
                                            <div className="received-buttons-container">
                                                <button className="received-button-left text-center" title="Accepter" onClick={() => onAcceptCapsule(assignment)}>
                                                    <img className="img-btn-card-checked" src={checkedImage} alt="check"></img>
                                                </button>
                                                <button className="d-button text-center" title="Diffuser" onClick={() => onDiffusionCapsule(assignment)}>
                                                    <img src={shareImage} className="img-btn-diff" alt="share"></img>
                                                </button>
                                                <button className="received-button-right text-center" title="Refuser" onClick={() => onDeclineCapsule(assignment)}>
                                                    <img className="img-btn-card-refused" src={refusedImage} alt="reject"></img>
                                                </button>
                                            </div> :
                                            <></>}
                                    </div>
                                )
                            })}


                        </div>

                    )}
                </DragScrollProvider>
            </div>
        );
    }
}

const ReceivedCardCarouselComponent = withRouter(withFirebase(ReceivedCardCarouselComponentBase));


export default ReceivedCardCarousel;
export { ReceivedCardCarouselComponent };